export default {
  setToken({ commit }, payload) {
    const linchpin = JSON.parse(payload);

    localStorage.setItem('token', linchpin.token);
    localStorage.setItem('linchpin', JSON.stringify(linchpin));
    commit('UPDATE_STATE_FROM_LOCALSTORAGE', null, { root: true });
  },
};
